// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerPackageUsageResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type CustomerPackageUsageApiResponse = {
	id: string;
	customerPackageId: string;
	compositionId: number;
	quantity: number;
	offerId: string | null;
	guestPriceId: string | null;
	bookingId: string | null;
	usedAt: string;
};

export type CustomerPackageUsage = {
	id: string;
	customerPackageId: string;
	compositionId: number;
	quantity: number;
	offerId: string | null;
	guestPriceId: string | null;
	bookingId: string | null;
	usedAt: DateTime;
};

export function hydrateCustomerPackageUsage(data: CustomerPackageUsageApiResponse): CustomerPackageUsage {
	return {
		...data,
		usedAt: DateTimefromISO(data.usedAt)!,
	};
}